export default __webpack_public_path__ + "static/PerformanceZoning-35d5e6d12dfae5e2ff9ddb603365bf93.png";